import COUNTRIES from '../countries.translations'

import { articleFigure } from './articleFigure'
import { articleMetal } from './articleMetal'
import translations from './story10.content'
import type { Article } from './types'

const t = translations
const dir = '/mine-my-phone/images/articles/story10'
const figure = articleFigure(dir)

export const story10: Article = {
  id: 10,
  slug: 'interview-michael-robinson-chavez-graphite-photography',
  order: 10,
  title: t.title,
  excerpt: t.excerpt,
  image: `${dir}/01.jpg`,
  imageCaption: [...t.captions[0]],
  metal: articleMetal('graphite'),
  author: 'India van Spall',
  // Five-town tag, so the pin goes to Mashan — offset from the graphite sheet's Luobei
  // marker, since stacked markers hide each other.
  region: [
    {
      name: t.regionName,
      country: COUNTRIES.china,
      coordinates: [130.58, 45.22],
      impact: 'human',
    },
  ],
  impactList: ['human', 'environmental'],
  content: {
    sections: [
      { type: 'prose', blocks: [...t.prose[0]] },
      figure('02.jpg', t.captions[1]),
      { type: 'quote', ...t.quotes[0] },
      { type: 'prose', blocks: [...t.prose[1]] },
      figure('03.jpg', t.captions[2]),
      { type: 'prose', blocks: [...t.prose[2]] },
      figure('04.jpg', t.captions[3]),
      { type: 'prose', blocks: [...t.prose[3]] },
      figure('05.jpg', t.captions[4]),
      { type: 'prose', blocks: [...t.prose[4]] },
      { type: 'quote', ...t.quotes[1] },
      { type: 'prose', blocks: [...t.prose[5]] },
      figure('06.jpg', t.captions[5]),
      { type: 'prose', blocks: [...t.prose[6]] },
    ],
  },
}
